<!--被驳回-->
<script>
import TablePage from '../../../../components/table_page';
import Form from '../../../process/components/process_approve/approve.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      tablePage: {
        // 分页
        pageSize: 8,
      },
      configs: {
        pagination: false,
        tableConfig: {
          border: 'inner',
        },
      },
      params: {
        bpmStatus: '4',
      },
      isCalculateHeight: false,
    };
  },
  created() {
    this.getConfigList('home-reject');
  },
  methods: {
    afterGetList() {
      this.$emit('rejectList', this.tablePage.totalResult);
    },
    setColumn(col) {
      const rowData = col;
      if (rowData.field === 'processTitle') {
        rowData.type = 'html';
        rowData.formatter = ({ cellValue }) => `<span style='color: #409eff;cursor: pointer;'>${cellValue || ''}</span>`;
      }
      return rowData;
    },
    cellClick({ row, column }) {
      if (column.property === 'processTitle') {
        this.modalConfig.title = '查看';
        this.modalConfig.type = 'EmptyDrawer';

        this.formConfig = {
          code: 'view',
          row,
        };
        this.openModal();
      }
    },
  },
};
</script>
